import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LogOnRq } from './log-on-rq';
import { SettingsClient, IGroupedRq, HistoricalDataReq } from '../../api/DixApiClient';
import { LogOnRs } from './log-on-rs';
import { AccountInformationResponseDTO, ApiMarketDTO, ChangedData, GetPriceTickResponseDTO, PriceTickDTO, GetPriceBarResponseDTO, NewTradeOrderRequestDTO, ApiClientAccountMarginResponseDTO, AccountInfo, ApiTradeOrderResponseDTO, GetGainOrderStatusReasons, ListActiveOrdersRequestDTO, SwitchAccountRs, AccountRs, ListActiveOrdersResponseDTO, TradeLinesImpl, OrdersDataImpl, OrderTypeId, ApiOrderDTO, PipsUPL, ApiIfDoneDTO, ApiStopLimitOrderDTO, ApiAssociatedDTO, GetOrderResponseDTO, CloseRs, TradeClosedRsImpl, PriceBarDTO, NewStopLimitOrderRequestDTO, INewTradeOrderRequestDTO, CancelOrderRequestDTO, OrderType, UpdateTradeOrderRequestDTO, ListTradeHistoryResponseDTO, ApiTradeHistoryDTO, ApiActiveOrderDTO, GetAllConnectedOrders } from './models';
import { WorkspaceServiceService } from '../workspace-service.service';

import { IServiceResponse, OrderRs, TradeLines, ISymbolInfo, TradeClosedRs, CancelRs, IEditRq, OrdersHistoryDataImpl } from "../../interfaces/service.response";
import { IQuotaData, symbolTypes } from '../../interfaces/quote.data';
import { LogOnInternalRs, ProviderAccount, ProviderInstrument } from './gainlogonresp';
import { HistoryItemPeriod, PERIOD_TIMESTAMP_MULTIPLIER, IPeriodsUpdate } from '../../interfaces/historyItem';
import { IServiceRequest } from '../../interfaces/service.request';
import { IntervalAndRepetition } from './IntervalAndRepetition';
import { Providers, IProvider } from '../../enums/providers';
import { TradeRequestModel, ICommonOrderRqData, EditRq } from '../../model/trade.request.data';
import { GetBaseCurrency } from '../../tools/utils';


import * as moment from "moment";
import { Ticket } from '../../components/tradedeskTabs/orders/tradeskOrdersTab/tradeskOrdersTab.component';
import { Period, CurrentPeriods, Quote } from '../../utils/Period';
import {request} from 'http';

declare var LightstreamerClient: any;
declare var Subscription: any;
declare var StatusWidget: any;


export enum GainPriceType {
    ASK = "ASK", MID = "MID", BID = "BID"
}

@Injectable({
    providedIn: 'root'
})
export class GainService implements IProvider {

    public static Instance: GainService;
    private _gainAppKey: string = "";
    private _gainURL: string = "";
    private sessionId: string = "";
    private lsClient: any;
    private userName: string = "";
    private tradingAccountId: number = 0;
    private tradingAccountIds:string[] = [];



    public nameDictionary: { [name: string]: string; } = {};
    private marketData: { [name: string]: { Bid: number, Ask: number, Price: number, TickDate: Date } } = {};
    private lastMarketData: { [name: string]: { Bid: number, Ask: number, Price: number, TickDate: Date } } = {};
    private currentPeriods: CurrentPeriods = new CurrentPeriods();

    //handlers for timers
    private handlerSendToDataService:any;
    private handlerSendTradeLines:any;

    private httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    };

    private PRICE_SUBSCRIPTION_FIELDS = ["MarketId", "TickDate", "Bid", "Offer", "Price" /*, "High", "Low", "Change", "Direction", "Delta", "ImpliedVolatility", "AuditId", "StatusSummary" */];
    private MARGIN_SUBSCRIPTION_FIELDS = ["Cash", "Margin", "MarginIndicator", "NetEquity", "OpenTradeEquity", "TotalMarginRequirement", "TradingAccountId", "CurrencyId", "CurrencyISO"];
    private STATUS_REASONS: string[];
    private INTERVALS: IntervalAndRepetition[] = [];



    constructor(private httpClient: HttpClient, private settingsClient: SettingsClient, private workspaceServiceService: WorkspaceServiceService) {

        this.settingsClient.getGainAppKey().toPromise().then(r => { this._gainAppKey = r.gainAppKey || ""; this._gainURL = r.gainURL || ""; });
        this.InitIntervals();
        this.STATUS_REASONS = GetGainOrderStatusReasons();

    }

    GetAPIURl(apiPath: string, hasQueryString: boolean = false): string {
        var separator = "?";
        if (hasQueryString) {
            separator = "&";
        }
        return this._gainURL + `${apiPath}${separator}UserName=${this.userName}&Session=${this.sessionId}`;
    }

    Get<T>(apiPath: string, hasQueryString: boolean = false): Promise<T> {
        return this.httpClient.get<T>(this.GetAPIURl(apiPath, hasQueryString), this.httpOptions).toPromise();
    }
    Post<T>(apiPath: string, body: any, hasQueryString: boolean = false): Promise<T> {
        return this.httpClient.post<T>(this.GetAPIURl(apiPath, hasQueryString), body, this.httpOptions).toPromise();
    }


    InitIntervals() {

        /*
        ,HistoryItemPeriod.Min2,HistoryItemPeriod.Min3,HistoryItemPeriod.Min5,HistoryItemPeriod.Min10,HistoryItemPeriod.Min15, HistoryItemPeriod.Min30,
        HistoryItemPeriod.Hr1, HistoryItemPeriod.Hr2, HistoryItemPeriod.Hr4, HistoryItemPeriod.H8,
        HistoryItemPeriod.Hr24
        */

        this.INTERVALS[HistoryItemPeriod.Min1] = new IntervalAndRepetition('MINUTE', 1, 1, HistoryItemPeriod.Min1);
        this.INTERVALS[HistoryItemPeriod.Min2] = new IntervalAndRepetition('MINUTE', 2, 2, HistoryItemPeriod.Min2);
        this.INTERVALS[HistoryItemPeriod.Min3] = new IntervalAndRepetition('MINUTE', 3, 3, HistoryItemPeriod.Min3);
        this.INTERVALS[HistoryItemPeriod.Min5] = new IntervalAndRepetition('MINUTE', 5, 5, HistoryItemPeriod.Min5);
        this.INTERVALS[HistoryItemPeriod.Min10] = new IntervalAndRepetition('MINUTE', 10, 10, HistoryItemPeriod.Min10);
        this.INTERVALS[HistoryItemPeriod.Min15] = new IntervalAndRepetition('MINUTE', 15, 15, HistoryItemPeriod.Min15);
        this.INTERVALS[HistoryItemPeriod.Min30] = new IntervalAndRepetition('MINUTE', 30, 30, HistoryItemPeriod.Min30);
        this.INTERVALS[HistoryItemPeriod.Hr1] = new IntervalAndRepetition('HOUR', 1, 60, HistoryItemPeriod.Hr1);
        this.INTERVALS[HistoryItemPeriod.Hr2] = new IntervalAndRepetition('HOUR', 2, 120, HistoryItemPeriod.Hr2);
        this.INTERVALS[HistoryItemPeriod.Hr4] = new IntervalAndRepetition('HOUR', 4, 240, HistoryItemPeriod.Hr4);
        this.INTERVALS[HistoryItemPeriod.H8] = new IntervalAndRepetition('HOUR', 8, 480, HistoryItemPeriod.H8);
        this.INTERVALS[HistoryItemPeriod.Hr24] = new IntervalAndRepetition('DAY', 1, 24 * 60, HistoryItemPeriod.Hr24);
        this.INTERVALS[HistoryItemPeriod.Week1] = new IntervalAndRepetition('WEEK', 1, 7 * 24 * 60, HistoryItemPeriod.Week1);

        this.currentPeriods.Init(this.INTERVALS);
    }


    public GetProviderIntervalsInfo(): HistoryItemPeriod[] {
        let periods: HistoryItemPeriod[] = [];
        for (var i in this.INTERVALS) {
            periods.push(parseInt(i));
        }


        return periods;
    }

    SwitchAccount(Data: any): void {
        
        var accountId:string = Data.AccountId;
        if(this.tradingAccountIds.indexOf(accountId)<0)
        {
            accountId = this.tradingAccountIds[0];
        }

        this.tradingAccountId = parseInt(Data.AccountId);

        let switchAccountRs: SwitchAccountRs = new SwitchAccountRs();
        switchAccountRs.ActiveAccount = new AccountRs();
        switchAccountRs.ActiveAccount.Id = this.tradingAccountId;

        this.workspaceServiceService.dataService.processResponse(switchAccountRs);
    }

    private GetOppositeDirection(direction: string): string {
        if (direction.toLowerCase() == "buy") {
            return "sell";
        }

        return "buy"
    }

    private GetStopOrLimitOrderDTO(order: INewTradeOrderRequestDTO, triggerPrice: number, orderId?:number): ApiStopLimitOrderDTO {
        let resp: ApiStopLimitOrderDTO = new ApiStopLimitOrderDTO();
        resp.Guaranteed = false;
        resp.TradingAccountId = order.TradingAccountId
        resp.TriggerPrice = triggerPrice;
        resp.Quantity = order.Quantity;
        resp.Direction = this.GetOppositeDirection(order.Direction);
        resp.OrderId = orderId;
        return resp;

    }




    private GetDistanceFromPips(pips: number, symbolInfo: ISymbolInfo): number {
        return pips / Math.pow(10, (symbolInfo.Decimals - 1));
    }

    private GetGainError(e: any) {
        var errorString = "Internal Error";
        if (e.error && e.error.ErrorMessage) {
            errorString = e.error.ErrorMessage;
        }
        return errorString;
    }

    CloseTrade(request: Ticket) {

        var closeRs: CloseRs = new CloseRs();

        this.Get<GetOrderResponseDTO>("/order/" + request.Ticket, false).then(orderResp => {

            if (orderResp.TradeOrder) {
                var order: NewTradeOrderRequestDTO = new NewTradeOrderRequestDTO();
                order.Direction = this.GetOppositeDirection(orderResp.TradeOrder.Direction);
                var directionSellBuy:string = orderResp.TradeOrder.Direction;
                order.Quantity = orderResp.TradeOrder.Quantity;
                order.MarketId = orderResp.TradeOrder.MarketId?orderResp.TradeOrder.MarketId:0;
                order.TradingAccountId = this.tradingAccountId;

                var currency: string = this.nameDictionary[order.MarketId];

                var quote: any = this.lastMarketData[currency];

                order.BidPrice = quote.Bid;
                order.OfferPrice = quote.Ask;

                order.Close.push(orderResp.TradeOrder.OrderId?orderResp.TradeOrder.OrderId:0);

                this.Post<ApiTradeOrderResponseDTO>("/order/newtradeorder", order, false).then(orderRespClose => {

                    let tradeClosedRs: TradeClosedRsImpl = new TradeClosedRsImpl(); 

                    tradeClosedRs.FillPrice = orderRespClose.Orders[0].Price;

                    var originalFillPrice: number = 0;

                    if (orderResp.TradeOrder)
                    {
                        originalFillPrice = orderResp.TradeOrder.Price?orderResp.TradeOrder.Price:0;
                    }                    

                    tradeClosedRs.Pips = this.GetPnL(tradeClosedRs.FillPrice, originalFillPrice, order.Quantity, currency, directionSellBuy ).Pips
                    tradeClosedRs.Profit = orderRespClose.Actions[0].ProfitAndLoss;
                    tradeClosedRs.Qty = order.Quantity;
                    
                    tradeClosedRs.Symbol = currency;

                    this.workspaceServiceService.dataService.processResponse(tradeClosedRs);

                    //place here TradeClosedRs 
                    this.sendTradeLinesWithTimeout();

                }).catch(e => {

                    closeRs.Error = this.GetGainError(e);

                    this.workspaceServiceService.dataService.processResponse(closeRs);

                });

            }
            else {
                closeRs.Error = "This is not a trade order !";
                this.workspaceServiceService.dataService.processResponse(closeRs);
            }



        }).catch(e => {

            closeRs.Error = this.GetGainError(e);

            this.workspaceServiceService.dataService.processResponse(closeRs);

        });

    }

    private PlaceMarket(request: TradeRequestModel)
    {
        var order: NewTradeOrderRequestDTO = new NewTradeOrderRequestDTO();
        this.PlaceOrder(request,order, "/order/newtradeorder");
    }


    private PlaceOrder(request: ICommonOrderRqData, order: INewTradeOrderRequestDTO, gainurl:string)
    {

        var orderRs: OrderRs = new OrderRs();

        var direction:number = request.Side.toLowerCase() == "sell" ? -1 : 1;

        var market: string = this.nameDictionary[request.Currency];

        order.MarketId = parseInt(market);
        order.Currency = GetBaseCurrency(request.Currency);
        order.Direction = request.Side.toLowerCase();
        order.Quantity = request.Quantity;
        order.TradingAccountId = this.tradingAccountId;

        var symbolInfo = this.GetSymbolInfo(request.Currency);

        if (!symbolInfo) {
            orderRs.OK = false;
            orderRs.Error = "Cannot obtain information about symbol !";
            this.workspaceServiceService.dataService.processResponse(orderRs);
            return;

        }

        var quote: any = this.lastMarketData[request.Currency];

        order.BidPrice = quote.Bid;
        order.OfferPrice = quote.Ask;


        var ifDone: ApiIfDoneDTO | undefined = undefined;

        if (request.LimitPrice != 0) {
            ifDone = new ApiIfDoneDTO();
            ifDone.Limit = this.GetStopOrLimitOrderDTO(order, request.LimitPrice, request.LimitOrderId);
        }
        else
        {
            if(request.LimitOrderId)
            {
                this.CancelOrder({Ticket:request.LimitOrderId.toString()});
            }
        }


        if (request.TrailingStopPips && request.TrailingStopPips > 0) {

            if (!ifDone) {
                ifDone = new ApiIfDoneDTO();
            }

            ifDone.Stop = this.GetStopOrLimitOrderDTO(order, 0, request.StopOrderId);

            ifDone.Stop.TrailingDistance = this.GetDistanceFromPips(request.TrailingStopPips, symbolInfo);

        }
        else if (request.StopPrice != 0) {
            if (!ifDone) {
                ifDone = new ApiIfDoneDTO();
            }
            ifDone.Stop = this.GetStopOrLimitOrderDTO(order, request.StopPrice, request.StopOrderId);
        }
        else
        {
            if(request.StopOrderId)
            {
                this.CancelOrder({Ticket:request.StopOrderId.toString()});
            }

        }

        if (ifDone && ifDone.Stop && ifDone.Limit) {
            //ifDone.Limit.OcoOrder = ifDone.Stop;

            //ifDone.Stop = undefined;            
            //ifDone.Stop.OcoOrder = ifDone.Limit;
            //var stopClone:any = JSON.parse(JSON.stringify(ifDone.Stop));
            //ifDone.Limit.OcoOrder = stopClone;
        }

        if (ifDone) {
            order.IfDone = [ifDone];
        }

        this.SendOrderToGain(order,gainurl, request);

    }

    private PlacePending(request: ICommonOrderRqData, orderId:number, url:string)
    {
        var order: NewStopLimitOrderRequestDTO = new NewStopLimitOrderRequestDTO();

        order.OrderId = orderId;

        var direction:number = request.Side.toLowerCase() == "sell" ? -1 : 1;

        var quote: any = this.lastMarketData[request.Currency];

        if(request.EnterPrice)
        {
            order.Guaranteed = false;// ( (direction==1?quote.Ask:quote.Bid) - request.EnterPrice ) * direction <= 0;
            order.TriggerPrice = request.EnterPrice;
        }

        this.PlaceOrder(request, order,url);
    }


    private SendOrderToGain<OT>(order:OT, url:string, request: ICommonOrderRqData)
    {
        var orderRs: OrderRs = new OrderRs();

        this.Post<ApiTradeOrderResponseDTO>(url, order, false).then(orderResp => {

            orderRs.Type = "OrderRs";
            orderRs.LimitPrice = 0;
            orderRs.StopPrice = 0;

            if (orderResp.StatusReason != 1) {
                orderRs.OK = false;
                orderRs.Error = this.STATUS_REASONS[orderResp.StatusReason];
            }
            else {
                orderRs.Currency = request.Currency;
                orderRs.OK = true;
                orderRs.Id = orderResp.OrderId.toString();
                orderRs.Quantity = request.Quantity;
                orderRs.Side = request.Side;
            }

            this.workspaceServiceService.dataService.processResponse(orderRs);
            this.sendTradeLinesWithTimeout();

        }).catch((r) => {


            var errorString = "Internal Error";
            if (r.error && r.error.ErrorMessage) {
                errorString = r.error.ErrorMessage;
            }

            orderRs.OK = false;
            orderRs.Error = errorString;

            this.workspaceServiceService.dataService.processResponse(orderRs);

            console.log(JSON.stringify(r));

        });

    }

    public OrderRequest(request: TradeRequestModel) {

        if(request.Type == TradeRequestModel.TYPE_MARKET)
        {
            this.PlaceMarket(request);                
            return;
        }

        this.PlacePending(request, 0, "/order/newstoplimitorder");                

    }

    public cansSendTradeLinse:boolean = true;

    LogOn(userName: string, password: string): Promise<LogOnInternalRs> {

        this.SwitchOff();

        return new Promise<LogOnInternalRs>((rs, rj) => {

            var logOnRq: LogOnRq = new LogOnRq();

            logOnRq.AppKey = this._gainAppKey;
            logOnRq.UserName = userName;
            logOnRq.Password = password;
            this.userName = userName;



            this.httpClient.post<LogOnRs>(this._gainURL + "/session", logOnRq, this.httpOptions).toPromise().then(r => {

                this.sessionId = r.Session;

                this.Get<AccountInformationResponseDTO>("/useraccount/ClientAndTradingAccount").then(accountInformation => {


                    var logonRs = new LogOnInternalRs();



                    accountInformation.TradingAccounts.forEach((tradingAccount) => {

                        var providerAccount = new ProviderAccount();
                        providerAccount.AccountID = tradingAccount.TradingAccountId.toString();
                        providerAccount.AccountName = tradingAccount.TradingAccountId.toString();
                        providerAccount.Balance = 0;
                        providerAccount.Currency = accountInformation.ClientAccountCurrency;
                        providerAccount.PnL = 0;
                        providerAccount.Provider = Providers.GAIN;
                        this.tradingAccountIds.push(providerAccount.AccountID);


                        if (this.tradingAccountId == 0) {
                            this.tradingAccountId = tradingAccount.TradingAccountId;
                        }

                        logonRs.ProviderAccounts.push(providerAccount);

                    });


                    //this.Get<ApiMarketDTO[]>("/market/searchpages?pageSize=100", true).then(markets => {
                    this.Get<ApiMarketDTO[]>("/market/searchwithtags?tagId=80&maxResults=200", true).then(markets => {
                        let priceSubscriptionItems: string[] = [];
                        (markets as any).Markets.forEach((item: ApiMarketDTO) => {
                            let name = item.MarketId.toString();
                            this.nameDictionary[name] = item.Name;
                            this.nameDictionary[item.Name] = name;

                            var providerInstrument = new ProviderInstrument();
                            providerInstrument.Symbol = item.Name;
                            providerInstrument.MarginPercentage = item.Weighting;

                            logonRs.ProviderInstruments.push(providerInstrument);

                            priceSubscriptionItems.push("PRICE." + name)

                            console.log(`market added:${item.Name}`);

                        })


                        this.subscribe(priceSubscriptionItems, this.PRICE_SUBSCRIPTION_FIELDS, 'PRICES').addListener(
                            {
                                onItemUpdate: (updateObject: any) => {
                                    let item: any = {};
                                    updateObject.forEachField((fieldName: string, fieldPos: number, val: string) => {
                                        item[fieldName] = val;
                                    });


                                    this._addToMarketData(item);
                                }
                            });

                        this.handlerSendToDataService = setInterval(() => {
                            this._sendToDataService();
                            
                        }, 1000);

                        
                        this.handlerSendTradeLines = setInterval(() => {
                            if(this.cansSendTradeLinse==true)
                            {
                                this.cansSendTradeLinse = false;
                                  this.sendTradeLines();
                            }
                          
                        }, 15000);


                        rs(logonRs);

                        this.sendTradeLinesWithTimeout();

                        setTimeout(() => {
                            this.sendTradeLinesWithTimeout();
                        }, 2000);

                        setTimeout(() => {
                            this.sendTradeLinesWithTimeout();
                        }, 4000);

                    });

                });

                console.log(r);

            }).catch(e => {

                var errorString = "Internal Error";
                if (e.error && e.error.ErrorMessage) {
                    errorString = e.error.ErrorMessage;
                }


                rj(new LogOnInternalRs(errorString));
                console.log(e);
            });

        });

    }
    private sendTradeLinesWithTimeout() {
        this.sendTradeLines();
    }

    private sendTradeLines() {
        let response: TradeLines = new TradeLinesImpl();

        this.Get<ApiClientAccountMarginResponseDTO>("/margin/ClientAccountMargin").then((respMoneyline) => {

            response.MoneyLine.AccountValue = respMoneyline.Cash;
            response.MoneyLine.Balance = respMoneyline.NetEquity;
            response.MoneyLine.MarginInUse = respMoneyline.Margin;
            //response.MoneyLine.PnL = resp.
            response.MoneyLine.SumOfUPLUSD = respMoneyline.OpenTradeEquity;

            let reqActiveOrders: ListActiveOrdersRequestDTO = new ListActiveOrdersRequestDTO();
            reqActiveOrders.TradingAccountId = this.tradingAccountId;
            reqActiveOrders.MaxResults = 1000;

            this.Post<ListActiveOrdersResponseDTO>("/order/activeorders", reqActiveOrders).then((respActiveOrders) => {

                console.log(`ListActiveOrdersResponseDTO:${JSON.stringify(respActiveOrders)}`);

                let associateOrdersSet:Set<number> = new Set<number>();
                
                respActiveOrders.ActiveOrders.forEach((activeOrder:ApiActiveOrderDTO) => {

                    var associatedOrders:ApiStopLimitOrderDTO[] = GetAllConnectedOrders(activeOrder);                        
                    associatedOrders.forEach(o=>{
                        associateOrdersSet.add(o.OrderId?o.OrderId:0);
                    }) ;

                });

                let sumOfPips: number = 0;

                respActiveOrders.ActiveOrders.forEach((activeOrder:ApiActiveOrderDTO) => {

                    let tradeLine: OrdersDataImpl = new OrdersDataImpl();

                    let baseOrder: ApiOrderDTO = new ApiOrderDTO();

                    if (activeOrder.StopLimitOrder) {
                        baseOrder = activeOrder.StopLimitOrder;
                        tradeLine.EditRq.Type = OrderType[OrderType.Pending];

                    }
                    if (activeOrder.TradeOrder) {
                        baseOrder = activeOrder.TradeOrder;
                        var moment = this.GetMomentFromGainString(activeOrder.TradeOrder.CreatedDateTimeUTC);
                        tradeLine.EntryTime = moment.format("YYYY-MM-DD HH:mm:ss");
                        tradeLine.EditRq.Type = OrderType[OrderType.Market];
                    }

                    if(associateOrdersSet.has(baseOrder.OrderId?baseOrder.OrderId:0))
                    {
                        return;                            
                    }

                    var associatedOrders:ApiStopLimitOrderDTO[] = GetAllConnectedOrders(activeOrder);                        
                    associatedOrders.forEach(o=>{
                        if(o.IsLimitInternal)
                        {
                            tradeLine.Limit = o.TriggerPrice;
                        }
                        else
                        {
                            tradeLine.Stop = o.TriggerPrice;
                        }
                    }) ;


                    let pair: string = this.nameDictionary[baseOrder.MarketId?baseOrder.MarketId:0];
                    var quote: any = this.lastMarketData[pair];
                    let tradeLineDirection = this.GetTradeLineDirectionFromGainDirection(baseOrder.Direction);
                    
                    let baseOrderId :number = baseOrder.OrderId?baseOrder.OrderId:0;

                    tradeLine.EditRq.Currency = pair;
                    tradeLine.EditRq.Id = baseOrderId
                    tradeLine.EditRq.Quantity = baseOrder.Quantity;
                    tradeLine.EditRq.Side = tradeLineDirection;
                    
                    
                    tradeLine.Symbol = pair;
                    
                    let marketPrice:number = 0;
                    if(quote)
                    {
                         marketPrice  = baseOrder.Direction.toLowerCase() == "buy" ? quote.Bid : quote.Ask;
                    }
                  

                    tradeLine.MarketPrice = marketPrice;
                    tradeLine.ID = baseOrderId;
                    tradeLine.Ticket = baseOrderId.toString();
                    tradeLine.EntryPrice = baseOrder.Price?baseOrder.Price:0;
                    tradeLine.Qty = baseOrder.Quantity;

                    tradeLine.MenuRequests.push("EditRq");    



                    if (activeOrder.TypeId == OrderTypeId.Limit || activeOrder.TypeId == OrderTypeId.Stop) {
                        if (activeOrder.StopLimitOrder) {

                            tradeLine.MenuRequests.push("CancelReq");


                            if (activeOrder.TypeId == OrderTypeId.Limit) {
                                tradeLine.Type = tradeLineDirection + " Limit";
                            }
                            else {
                                tradeLine.Type = tradeLineDirection + " Stop";
                            }
                            tradeLine.Qty = activeOrder.StopLimitOrder.Quantity;
                            tradeLine.EntryPrice = activeOrder.StopLimitOrder.TriggerPrice;
                            

                            var moment = this.GetMomentFromGainString(activeOrder.StopLimitOrder.LastChangedDateTimeUTC?activeOrder.StopLimitOrder.LastChangedDateTimeUTC:"");
                            tradeLine.EntryTime = moment.format("YYYY-MM-DD HH:mm:ss");
                                
                        }

                    }
                    else {
                        if (activeOrder.TradeOrder) {
                            tradeLine.Type = tradeLineDirection;
                            tradeLine.MenuRequests.push("CloseReq");

                            var pnlPips = marketPrice == 0 ? new PipsUPL() : this.GetPnL(marketPrice, activeOrder.TradeOrder.Price?activeOrder.TradeOrder.Price:0, activeOrder.TradeOrder.Quantity, pair, baseOrder.Direction);
                            tradeLine.PnLUSD = pnlPips.UPL;
                            tradeLine.Pips = this.PipsToString(pnlPips.Pips);

                            sumOfPips += pnlPips.Pips;

                        }
                    }


                    response.Lines.push(tradeLine);


                });

                response.MoneyLine.SumOfPips = this.PipsToString(sumOfPips);

                let twoYearsAgo:number =  moment().add(-2, "years").unix();                                    

                this.Get<ListTradeHistoryResponseDTO>(`/order/tradehistory?TradingAccountId=${this.tradingAccountId}&maxResults=10000&from=${twoYearsAgo}`,true).then((listHistoryOrders) => {                                    


                    let dictOrders: { [orderId: number]: ApiTradeHistoryDTO } = {};

                    listHistoryOrders.TradeHistory.forEach(historyItem=>{

                        dictOrders[historyItem.OrderId] = historyItem;
                        
                    });  

                    listHistoryOrders.TradeHistory.forEach(historyItem=>{



                        if(historyItem.OpeningOrderIds.length==1 && historyItem.OrderId == historyItem.OpeningOrderIds[0])
                        {
                            //position was opened by itself
                        }
                        else
                        {
                            let historyLine:OrdersHistoryDataImpl = new OrdersHistoryDataImpl();
    

                            historyLine.ClosePrice =  historyItem.Price.toString();                                                               
                            var moment = this.GetMomentFromGainString(historyItem.ExecutedDateTimeUtc);
                            historyLine.CloseTime = moment.format("YYYY-MM-DD HH:mm:ss");
    
                            var totalPrice:number=0;
                            var totalQty:number=0;                            
                            
                            historyItem.OpeningOrderIds.forEach(orderid=>{
                                var openingOrder:ApiTradeHistoryDTO = dictOrders[orderid];
                                let originalQty:number = openingOrder.OriginalQuantity?openingOrder.OriginalQuantity:0;
                                totalPrice +=  openingOrder.Price*originalQty;
                                totalQty += originalQty;

                                var moment = this.GetMomentFromGainString(openingOrder.ExecutedDateTimeUtc);
                                historyLine.EntryTime = moment.format("YYYY-MM-DD HH:mm:ss");

                                historyLine.Type = this.GetTradeLineDirectionFromGainDirection( openingOrder.Direction );
                                historyLine.Ticket = openingOrder.OrderId.toString();
    
                            });

                            var symbolInfo = this.GetSymbolInfo(historyItem.MarketName);
                            let entryPrice:number =  totalPrice/totalQty;  

                            historyLine.EntryPrice = symbolInfo ? entryPrice.toFixed(symbolInfo.Decimals) : entryPrice.toString();                                            

                            let originalQty:number = historyItem.OriginalQuantity?historyItem.OriginalQuantity:0;

                            historyLine.Qty = originalQty.toString();

                            historyLine.Pips = this.GetPnL(historyItem.Price,entryPrice, originalQty, historyItem.MarketName, historyLine.Type ).Pips.toString();
                            historyLine.PnLUSD = historyItem.RealisedPnl.toString();
                            historyLine.Symbol = historyItem.MarketName;
                            
                            response.HistoryLines.push(historyLine);   

                        }

                        

                    });  

                 
                    this.workspaceServiceService.dataService.processResponse(response);
                    this.cansSendTradeLinse = true;
                });



            });




        });


        //response.MoneyLine.

    }

    private GetTradeLineDirectionFromGainDirection(gainDirection:string):string
    {
        return gainDirection.toLowerCase()=="buy" ? "Buy" : "Sell";
            
    }
    

    private GetSymbolInfo(symbol: string): ISymbolInfo | undefined {
        return this.workspaceServiceService.data.SymbolInfoes.find(s => s.Symbol == symbol);
    }

    private GetPnL(marketPrice: number, fillPrice: number, qty: number, symbol: string, directionBuySell:string): PipsUPL {
        let pipsUPL: PipsUPL = new PipsUPL();

        let directionInt:number = directionBuySell.toLowerCase() == "buy" ? 1 : -1;

        var symbolInfo = this.GetSymbolInfo(symbol);

        if (!symbolInfo) {
            return pipsUPL;
        }

        let priceDifference: number = (marketPrice - fillPrice) * directionInt;


        pipsUPL.Pips = Math.round(priceDifference * Math.pow(10, (symbolInfo.Decimals - 1)) * 10) / 10;

        var exchangeRate = this.GetExchangeRate(symbol, qty > 0);

        pipsUPL.UPL = Math.round(Math.abs(qty) * priceDifference * exchangeRate * 100) / 100;

        return pipsUPL;

    }
    private PipsToString(pips: number): number {
        if (pips < 1 && pips > -1) {
            return pips;
        }
        else {
            return Math.round(pips);
        }

    }

    GetExchangeRate(symbol: string, isBuy: boolean): number {

        if (symbol.indexOf("/") < 0) {
            return 1;
        }

        let currency: string = symbol.substring(symbol.length - 3);

        if (currency == "USD") {
            return 1;
        }

        let q1: string = `${currency}/USD`;

        var quote: any = this.lastMarketData[q1];

        if (!quote) {
            let q2: string = `USD/${currency}`;
            var quote: any = this.lastMarketData[q2];

            if (!quote) {
                return 0;
            }

            let price: number = isBuy ? quote.Ask : quote.Bid;

            if (price == 0) {
                return 1;
            }

            return 1 / price;
        }

        return isBuy ? quote.Ask : quote.Bid;

    }



    private _sendToDataService() {
        if (Object.keys(this.marketData).length == 0) {
            return;
        }

        let quoteData: IQuotaData[] = [];
        Object.keys(this.marketData).forEach(key => {
            let data = this.marketData[key];
            quoteData.push({ A: data.Ask, B: data.Bid, D: 0, S: key });
        });

        


        let periods: IPeriodsUpdate[] = this.currentPeriods.GetChangedPeriods().map(period => {
            return {
                Symbol: period.PeriodType.Symbol,
                PeriodType: period.PeriodType.IntervalAndRepetition.PeriodInterval,
                Period: {
                    t: period.GetPeriodStart(),
                    o: period.Open,
                    c: period.Close,
                    h: period.High,
                    l: period.Low,
                    v: period.PeriodType.IntervalAndRepetition.NumerOfMinutes * 175
                }
            }
        });


        let serviceResponse: IServiceResponse = {
            T: quoteData,
            P: periods
        }

        this.marketData = {};
        this.workspaceServiceService.dataService.processResponse(serviceResponse);

    }


    HistoricalData(reqArray: HistoricalDataReq[]) {


        reqArray.forEach(histReq => {

            var reqId: string = (<any>histReq)["ReqID"];
            var periodNumber: number = (<any>histReq)["Period"];
            var symbol: string = (<any>histReq)["Symbol"];
            var intervalAndPoints: IntervalAndRepetition = this.INTERVALS[periodNumber];

            if (!intervalAndPoints) {
                //no period exiting
                return;
            }

            var market: string = this.nameDictionary[symbol];
            var priceBars: number = (<any>histReq)["Points"];
            var gainURL: string = `/market/${market}/barhistory?interval=${intervalAndPoints.Interval}&span=${intervalAndPoints.Repetition}&PriceBars=${priceBars}`;

            console.log("gainURL")
            console.log([market, symbol])
            this.Get<GetPriceBarResponseDTO>(gainURL, true).then(r => {


                var singleResp: IServiceResponse = {
                    Type: "HistoricalDataRs",
                    ReqID: reqId,
                    Symbol: symbol,
                    Period: periodNumber,
                    Periods: []
                };

                singleResp.Periods = r.PriceBars.map(period => {
                    return {
                        h: period.High,
                        l: period.Low,
                        o: period.Open,
                        c: period.Close,
                        v: intervalAndPoints.NumerOfMinutes * 175,
                        t: this.GetLocalUnixTimestampFromGainString(period.BarDate)
                    }
                })

                

                if (r.PartialPriceBar)
                {                    
                    var periodStart: number = this.GetLocalUnixTimestampFromGainString(r.PartialPriceBar.BarDate);
                    singleResp.Periods.push({ h: r.PartialPriceBar.High, l: r.PartialPriceBar.Low, o: r.PartialPriceBar.Open, c: r.PartialPriceBar.Close, v: intervalAndPoints.NumerOfMinutes * 175, t:  periodStart })
                }

                var lastPriceBar: PriceBarDTO = (r.PartialPriceBar) ? r.PartialPriceBar : r.PriceBars[r.PriceBars.length - 1];
                var periodStart: number = this.GetLocalUnixTimestampFromGainString(lastPriceBar.BarDate);


                var period: Period = new Period();


                period.PeriodType.IntervalAndRepetition = intervalAndPoints;
                period.PeriodType.Symbol = symbol;

                period.End = periodStart + intervalAndPoints.NumerOfMinutes * 60;


                period.Close = lastPriceBar.Close;
                period.High = lastPriceBar.High;
                period.Low = lastPriceBar.Low;
                period.Open = lastPriceBar.Open;

                this.currentPeriods.IntroduceNewPeriod(period);


                

                // r.PriceBars.forEach(period=>{
                //   if(!singleResp.Periods)
                //   {
                //     return;            
                //   }
                //   var timestamp = this.GetMomentFromGainString(period.BarDate);
                //   singleResp.Periods.push({h:period.High,l:period.Low,o:period.Open, c:period.Close, v:intervalAndPoints.NumerOfMinutes*175, t:timestamp.unix()})
                // });




                this.workspaceServiceService.dataService.processResponse(singleResp);


                console.log("Gain historical data sent to data service");

            });

        });



    }
    private GetLocalUnixTimestampFromGainString(gainString: string): number {
        var date: moment.Moment = this.GetMomentFromGainString(gainString);
        return date.unix() + date.utcOffset() * 60;
    }

    private GetMomentFromGainString(gainString: string): moment.Moment {
        return moment(parseInt(gainString.substr(6))).tz("America/New_York");
    }

    private _addToMarketData(item: ChangedData) {
        if (!item || !item.MarketId) {
            return;
        }

        
        var symbol: string = this.nameDictionary[item.MarketId.toString()];
        var marketData: any = {
            Ask: Number(item.Offer),
            Bid: Number(item.Bid),
            TickDate: new Date(),
            Price: Number(item.Price)
        };

        var quote: Quote = new Quote();
        quote.Ask = marketData.Ask;
        quote.Bid = marketData.Bid;
        quote.Symbol = symbol;

        this.currentPeriods.RegisterTick(quote);


        this.marketData[symbol] = marketData;
        this.lastMarketData[symbol] = marketData;
    }

    subscribe(items: string[], fields: string[], dataAdapter: string) {
        const subscription = new Subscription('MERGE', items, fields);

        this.lsClient = new LightstreamerClient("https://push.cityindex.com/");
        //lsClient.connectionSharing.enableSharing('DemoCommonConnection', 'ATTACH', 'CREATE');
        this.lsClient.connectionDetails.setUser(this.userName);
        this.lsClient.connectionDetails.setPassword(this.sessionId);
        this.lsClient.connectionDetails.setAdapterSet("STREAMINGALL");

        subscription.setDataAdapter(dataAdapter);


        //lsClient.addListener(new StatusWidget('left', '0px', true));
        this.lsClient.connect();
        this.lsClient.subscribe(subscription);

        return subscription;
    }

    disconnectLightStreamer() {
        this.lsClient.disconnect();
    }


    CancelOrder(Data: Ticket): void 
    {
        var cancelOrder:CancelOrderRequestDTO  = new  CancelOrderRequestDTO();
        cancelOrder.OrderId = parseInt( Data.Ticket );
        cancelOrder.TradingAccountId = this.tradingAccountId;

        var cancelRs:CancelRs = new CancelRs();

        this.Post<ApiTradeOrderResponseDTO>("/order/cancel", cancelOrder, false).then(orderResp => {

            cancelRs.Type = "CancelRs";

            if (orderResp.Orders && orderResp.Orders.length>0) {
                if (orderResp.StatusReason != 1) {
                    cancelRs.OK = false;
                    cancelRs.Error = this.STATUS_REASONS[orderResp.StatusReason];
                }
                else {
                    cancelRs.OK = true;
                    cancelRs.Error = "";
                }
            }
            else {
                cancelRs.OK = false;
                cancelRs.Error = "Provider sent malformed response";
            }

            this.workspaceServiceService.dataService.processResponse(cancelRs);

        }).catch((r) => {


            var errorString = "Internal Error";
            if (r.error && r.error.ErrorMessage) {
                errorString = r.error.ErrorMessage;
            }

            cancelRs.OK = false;
            cancelRs.Error = errorString;

            this.workspaceServiceService.dataService.processResponse(cancelRs);

            console.log(JSON.stringify(r));

        });

    }

    SwitchOff(): void {
        
        if(this.tradingAccountId!=0)
        {
            clearInterval(this.handlerSendToDataService);
            clearInterval(this.handlerSendTradeLines);
            this.tradingAccountIds = [];
            this.tradingAccountId = 0;
            this.disconnectLightStreamer();
        }
    }




    EditOrder(editRq: EditRq): void 
    {
        let orderType:OrderType = (<any>OrderType)[editRq.Type];           
        let orderId:number = parseInt(editRq.Id);  

        this.Get<GetOrderResponseDTO>(`/order/${orderId}`, false).then(orderResp => {

            switch(orderType)
            {
                case OrderType.Market:

                    if(orderResp.TradeOrder)
                    {
                        editRq.SetSLOrderIds(orderResp.TradeOrder);                            
                    }

                    let updateTradeOrderRequestDTO:UpdateTradeOrderRequestDTO = new UpdateTradeOrderRequestDTO();                
                    updateTradeOrderRequestDTO.OrderId = orderId;
                    this.PlaceOrder(editRq, updateTradeOrderRequestDTO,"/order/updatetradeorder");


                    break;
                case OrderType.Pending:

                    if(orderResp.StopLimitOrder)
                    {                            
                        editRq.SetSLOrderIds(orderResp.StopLimitOrder);                            
                    }
    
                    this.PlacePending(editRq, orderId,"/order/updatestoplimitorder");
                    break;
            }
    

        });



    }


}
